import axios from "axios";
import React, { useContext, useEffect, useState as reactUseState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Oval } from "react-loading-icons";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { HashLoader } from "react-spinners";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Transition } from "@headlessui/react";
import ReactTooltip from "react-tooltip";
import useState from "react-usestateref"; // Assuming this is the intended useState for most of the component
import { MenuIcon, XIcon } from "@heroicons/react/outline"; // Added
import Chatfeed from "../components/Chatfeed";
import ChatHeader from "../components/Chatheader";
import ChatInput from "../components/ChatInput";
import ChatRow from "../components/ChatRow";
import "../components/ChatRow.css";
import Friends from "../components/Friends";
import Groups from "../components/Groups";
import CodeSpace from "../components/CodeSpace";
import SearchBar from "../components/SearchBar";
import SearchUser from "../components/SearchUser";
import TopHeader from "../components/TopHeader";
import VerticalMenu from "../components/VerticalMenu";
import backendService from "../services.js/backendService";
import { SocketContext } from "../services.js/socket";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchInterval: 60000,
      refetchOnReconnect: true,
      staleTime: 40000,
    },
  },
});

function MainScreen() {
  const { screen, conversationId } = useParams();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = reactUseState(false); // Added for hamburger menu
  const [mobileView, setMobileView, mobileViewRef] = useState('list'); // Added for mobile view switching
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const [closeSearchUser, setCloseSearchUser] = useState(false);
  const [friends, setFriends] = useState(
    screen && screen === "friends" ? true : false
  );
  const [currentConvo, setCurrentConvo, currentConvoRef] = useState(null);
  const [currentOpenedConvo, setCurrentOpenedConvo] = useState(
    conversationId ? conversationId : null
  );
  const [isLoading, setIsLoading] = useState(true);
  const [newMessage, setNewMessage] = useState(null);
  const [groups, setGroups] = useState(
    screen && screen === "groups" ? true : false
  );
  const [codeSpace, setCodeSpace] = useState(
    screen && screen === "codespace" ? true : false
  );
  const [clicked, setClicked] = useState(null);
  const socket = useContext(SocketContext);
  const [createButtonPress, setCreateButtonPress] = useState(null);
  const [searchRecentsText, setSearchRecentsText] = useState("");
  const [hasPages, setHasPages, hasPagesRef] = useState(false);
  const [page, setPages] = useState(2);
  const [people, setPeople, setPeopleRef] = useState([]);
  const [notifications, setNotifications, notificationsRef] = useState(null);
  const [messages, setMessages, messageRef] = useState([]);
  const [inputText, setInputText] = useState("");
  const [contacts, setContacts, contactsRef] = useState([]);
  const [profilePicture, setProfilePicture] = useState(
    backendService.getLoggedInUser()["profilePicture"]
  );

  const getCreateButtonState = (data) => {
    setCreateButtonPress(data);
  };
  window.onunload = () => {
    if (localStorage.getItem("rememberMe") === "false") {
      localStorage.clear();
    }
  };
  useEffect(() => {
    setFriends(screen && screen === "friends" ? true : false);
    setGroups(screen && screen === "groups" ? true : false);
    setCodeSpace(screen && screen === "codespace" ? true : false);
    setCurrentOpenedConvo(conversationId ? conversationId : null);
    if (conversationId) {
      setMobileView('chat');
    } else {
      setMobileView('list');
    }
  }, [screen, conversationId]);

  const refreshConvo = (data) => {
    let newUserArray = data.map((item) => item._id);
    let oldUserArray = currentConvoRef.current.participants.map(
      (item) => item._id
    );

    if (
      currentConvoRef.current !== null &&
      oldUserArray.find((item) => newUserArray.includes(item))
    ) {
      setCurrentConvo({ ...currentConvoRef.current, lastUpdated: new Date() });
    }
  };

  const refreshConvoAlt = (data) => {
    setClicked(data);
    setCurrentConvo({ ...currentConvoRef.current, lastUpdated: new Date() });
  };

  const getAllContacts = async (data) => {
    setContacts(data);
    const handleRecents = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/getgroups`, {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        });
        return res.data.groups;
      } catch (error) {
        console.log(error);
      }
    };
    await handleRecents().then((data) => {
      setContacts((prev) => [...prev, ...data]);
    });
  };
  const getRecentSearchText = (data) => {
    setSearchRecentsText(data);
  };
  const getForwardMessage = (data) => {
    setClicked(data);
  };
  const getNotifications = (data) => {
    setNotifications(data);
  };
  const getDeleteMessage = (data) => {
    setMessages((msg) => {
      return msg.filter((item) => {
        return item._id !== data;
      });
    });
  };

  const getNotificationSettings = (conversationId) => {
    const setting = contactsRef.current.find(
      (item) => item._id === conversationId
    );
    if (
      setting?.notificationState.length === 0 ||
      setting?.notificationState[0]?.status === true
    ) {
      return true;
    } else {
      return false;
    }
  };

  const editedCode = (data) => {
    //update set message by id
    setMessages((msg) => {
      return msg.map((item) => {
        if (item._id === data._id) {
          return data;
        } else {
          return item;
        }
      });
    });
    setClicked(new Date());
  };
  useEffect(() => {
    socket.on("getEditCode", ({ message, messageID }) => {
      setMessages((msg) => {
        return msg.map((item) => {
          if (item._id === messageID) {
            return message;
          } else {
            return item;
          }
        });
      });
    });
  }, [socket]);
  useEffect(() => {
    socket.on("userAdded", (data) => {
      console.warn({ data });
    });
  }, [socket]);

  const [profilePictureLoaded, setProfilePictureLoaded] = useState(false);
  useEffect(async () => {
    setProfilePicture(backendService.getLoggedInUser()["profilePicture"]);
    setProfilePictureLoaded(true);
  }, [
    profilePictureLoaded,
    backendService.getLoggedInUser()["profilePicture"],
  ]);

  const handleBackToList = () => {
    setMobileView('list');
    setCurrentConvo(null);
    setCurrentOpenedConvo(null);
    // Optional: setIsMobileMenuOpen(false); // If the main menu should also close
  };

  const searchUserOpen = (data) => {
    setOpenSearchUser(data);
  };

  const searchUserClose = (data) => {
    setCloseSearchUser(data);
  };
  const getData = (data) => {
    setCurrentConvo(data);
    setCurrentOpenedConvo(data.participants[0]._id);
    setMobileView('chat');
  };
  const getCurrentOpenedConvo = (data) => {
    setCurrentOpenedConvo(data);
  };
  const friendsTab = (data) => {
    setFriends(data);
  };

  const getInputText = (data) => {
    setInputText(data);
  };
  const groupsTab = (data) => {
    setGroups(data);
  };
  const codeSpaceTab = (data) => {
    setCodeSpace(data);
  };
  const getImageData = async (data) => {
    const formData = new FormData();
    const createdAt = new Date();

    formData.append("createdAt", createdAt);
    const msg = {
      senderId: backendService.getLoggedInUser()._id,
      receiverId: currentConvo.participants[0]._id,
      content: "file",
      contentType: "file",
      conversationId: currentConvo._id,
      createdAt: createdAt,
      status: "sending",
      filename: data.name,
    };
    setMessages([...messages, msg]);

    formData.append("file", data);
    await axios
      .post(
        `${process.env.REACT_APP_URL}/sendimage/` + currentConvo._id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        if (res.data.message.conversationId === currentConvoRef.current._id) {
          setMessages((msg) => {
            return msg.map((item) => {
              return item.createdAt === createdAt ? res.data.message : item;
            });
          });
        }
        setClicked(new Date());
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: currentConvo.participants[0]._id,
          content: "image",
          contentType: "image",
          conversationId: currentConvo._id,
          createdAt: createdAt,
          data: res.data.message.data,
        };
        if (currentConvo.state === "grouped") {
          currentConvo.participants.forEach((participant) => {
            const msg = {
              senderId: backendService.getLoggedInUser()._id,
              receiverId: participant._id,
              content: "image",
              contentType: "image",
              conversationId: currentConvo._id,
              createdAt: createdAt,
              data: res.data.message.data,
            };
            socket.emit("sendMessage", msg);
          });
        } else {
          socket.emit("sendMessage", msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAudioData = async (data) => {
    const formData = new FormData();

    const createdAt = new Date();
    formData.append("file", data);
    formData.append("createdAt", createdAt);
    const msg = {
      senderId: backendService.getLoggedInUser()._id,
      receiverId: currentConvo.participants[0]._id,
      content: "file",
      contentType: "file",
      conversationId: currentConvo._id,
      createdAt: createdAt,
      status: "sending",
      filename: "Voice Note",
    };
    setMessages([...messageRef.current, msg]);
    await axios
      .post(
        `${process.env.REACT_APP_URL}/sendaudio/` + currentConvo._id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        if (res.data.message.conversationId === currentConvoRef.current._id) {
          setMessages((msg) => {
            return msg.map((item) => {
              return item.createdAt === createdAt ? res.data.message : item;
            });
          });
        }
        setClicked(new Date());
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: currentConvo.participants[0]._id,
          content: "audio",
          contentType: "audio",
          conversationId: currentConvo._id,
          createdAt: createdAt,
          data: res.data.message.data,
        };
        if (currentConvo.state === "grouped") {
          currentConvo.participants.forEach((participant) => {
            const msg = {
              senderId: backendService.getLoggedInUser()._id,
              receiverId: participant._id,
              content: "audio",
              contentType: "audio",
              conversationId: currentConvo._id,
              createdAt: createdAt,
              data: res.data.message.data,
            };

            socket.emit("sendMessage", msg);
          });
        } else {
          socket.emit("sendMessage", msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getVideoData = async (data) => {
    const formData = new FormData();

    formData.append("file", data);
    const createdAt = new Date();
    formData.append("createdAt", createdAt);

    const msg = {
      senderId: backendService.getLoggedInUser()._id,
      receiverId: currentConvo.participants[0]._id,
      content: "file",
      contentType: "file",
      conversationId: currentConvo._id,
      createdAt: createdAt,
      status: "sending",
      filename: data.name,
    };
    setMessages([...messageRef.current, msg]);
    await axios
      .post(
        `${process.env.REACT_APP_URL}/sendvideo/` + currentConvo._id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        if (res.data.message.conversationId === currentConvoRef.current._id) {
          setMessages((msg) => {
            return msg.map((item) => {
              return item.createdAt === createdAt ? res.data.message : item;
            });
          });
        }
        setClicked(new Date());
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: currentConvo.participants[0]._id,
          content: "video",
          contentType: "video",
          conversationId: currentConvo._id,
          createdAt: createdAt,
          data: res.data.message.data,
        };
        if (currentConvo.state === "grouped") {
          currentConvo.participants.forEach((participant) => {
            const msg = {
              senderId: backendService.getLoggedInUser()._id,
              receiverId: participant._id,
              content: "video",
              contentType: "video",
              conversationId: currentConvo._id,
              createdAt: createdAt,
              data: res.data.message.data,
            };
            socket.emit("sendMessage", msg);
          });
        } else {
          socket.emit("sendMessage", msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFileData = async (data) => {
    const formData = new FormData();

    const createdAt = new Date();
    formData.append("file", data);
    formData.append("createdAt", createdAt);
    const msg = {
      senderId: backendService.getLoggedInUser()._id,
      receiverId: currentConvo.participants[0]._id,
      content: "file",
      contentType: "file",
      conversationId: currentConvo._id,
      createdAt: createdAt,
      status: "sending",
      filename: data.name,
    };

    setMessages([...messageRef.current, msg]);
    await axios
      .post(
        `${process.env.REACT_APP_URL}/sendfile/` + currentConvo._id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        if (res.data.message.conversationId === currentConvoRef.current._id) {
          setMessages((msg) => {
            return msg.map((item) => {
              return item.createdAt === createdAt ? res.data.message : item;
            });
          });
        }
        setClicked(new Date());
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: currentConvo.participants[0]._id,
          content: "file",
          contentType: "file",
          conversationId: currentConvo._id,
          createdAt: createdAt,
          data: res.data.message.data,
        };
        if (currentConvo.state === "grouped") {
          currentConvo.participants.forEach((participant) => {
            const msg = {
              senderId: backendService.getLoggedInUser()._id,
              receiverId: participant._id,
              content: "file",
              contentType: "file",
              conversationId: currentConvo._id,
              createdAt: createdAt,
              data: res.data.message.data,
            };
            socket.emit("sendMessage", msg);
          });
        } else {
          socket.emit("sendMessage", msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCodeData = async (data) => {
    const createdAt = new Date();
    const msg = {
      senderId: backendService.getLoggedInUser()._id,
      receiverId: currentConvo.participants[0]._id,
      content: data.Code,
      contentType: "code/" + data.Language + "/" + data.compilerCode,
      conversationId: currentConvo._id,
      status: "sending",
      createdAt: createdAt,
    };
    if (currentConvo.state === "grouped") {
      currentConvo.participants.forEach((participant) => {
        const msg = {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: participant._id,
          content: data.Code,
          contentType: "code/" + data.Language + "/" + data.compilerCode,
          conversationId: currentConvo._id,
          status: "sending",
          createdAt: createdAt,
        };
        socket.emit("sendMessage", msg);
      });
    } else {
      socket.emit("sendMessage", msg);
    }
    setClicked(new Date());
    setMessages([...messageRef.current, msg]);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/sendcodemessage`,
        {
          conversationId: currentConvo,
          content: data.Code,
          language: data.Language + "/" + data.compilerCode,
          createdAt: createdAt,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      if (
        response.data.message.conversationId === currentConvoRef.current._id
      ) {
        setMessages((msg) => {
          return msg.map((item) => {
            return item.createdAt === createdAt ? response.data.message : item;
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendMessage = async () => {
    if (inputText.length > 0) {
      const createdAt = new Date();
      const newMessage = {
        conversationId: currentConvo,
        content: inputText,
        createdAt: createdAt,
      };
      const msg = {
        senderId: backendService.getLoggedInUser()._id,
        receiverId: currentConvo.participants[0]._id,
        content: inputText,
        contentType: "text",
        conversationId: currentConvo._id,
        status: "sending",
        createdAt: createdAt,
      };
      if (currentConvo.state === "grouped") {
        currentConvo.participants.forEach((participant) => {
          const msg = {
            senderId: backendService.getLoggedInUser()._id,
            receiverId: participant._id,
            content: inputText,
            contentType: "text",
            conversationId: currentConvo._id,
            status: "sending",
            createdAt: createdAt,
          };
          socket.emit("sendMessage", msg);
        });
      } else {
        socket.emit("sendMessage", msg);
      }
      setClicked(new Date());
      setMessages([...messageRef.current, msg]);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/sendtextmessage`,
          newMessage,
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": backendService.getToken(),
            },
          }
        );

        if (
          response.data.message.conversationId === currentConvoRef.current._id
        ) {
          setMessages((msg) => {
            return msg.map((item) => {
              return item.createdAt === createdAt
                ? response.data.message
                : item;
            });
          });
        }
        setInputText("");
      } catch (err) {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    async function handleMessage(id) {
      try {
        setIsLoading(true);
        setHasPages(false);
        setPages(2);
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/getmessages/${id}?perPage=20`,
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": backendService.getToken(),
            },
          }
        );
        setMessages(response.data.messages.reverse());

        setHasPages(response.data.hasNextPage);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    }
    if (currentConvo) {
      handleMessage(currentConvo?._id);
      setMobileView('chat');
    } else {
      setMobileView('list');
    }
  }, [currentConvo]);
  const infiniteMessage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/getmessages/${currentConvo._id}?page=${page}?perPage=20`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setMessages((prev) => [...response.data.messages.reverse(), ...prev]);
      setHasPages(response.data.hasNextPage);
      setPages(page + 1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    async function handleMessage(id) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/getmessages/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": backendService.getToken(),
            },
          }
        );
        setMessages(response.data.messages.reverse());
      } catch (error) {
        console.log(error);
      }
    }
    if (currentConvo) {
      handleMessage(currentConvo?._id);
    }
  }, [newMessage]);
  useEffect(() => {
    socket.on("getMessage", (data) => {
      setNewMessage(data);
    });
  }, []);
  useEffect(() => {
    socket.on("getDeleteMessage", (msgID) => {
      setClicked(new Date());
      setMessages((prev) => {
        return prev.filter((item) => item._id !== msgID);
      });
    });
  }, []);
  useEffect(() => {
    const handleFriends = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/getfriends`, {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        });

        setPeople(res.data.friends);
      } catch (error) {
        console.log(error);
      }
    };
    handleFriends();
  }, []);

  const getName = (id) => {
    const person = people.find((person) => person._id === id);
    return person.username;
  };
  const getProfilePic = (id) => {
    const person = people.find((person) => person._id === id);
    return person.profilePicture;
  };

  const isGroup = (id) => {
    const person = people.find((person) => person.conversationId === id);
    if (person) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (
      newMessage &&
      currentConvo?.participants[0]._id === newMessage.senderId
    ) {
      setMessages((prev) => [...prev, newMessage]);
      if (
        notifications &&
        getNotificationSettings(newMessage?.conversationId)
      ) {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted" && document.hidden) {
            new Notification(getName(newMessage.senderId), {
              body: `Message: ${newMessage.content}`,
              icon: getProfilePic(newMessage.senderId),
            }).onclick = () => {
              if (isGroup(newMessage.conversationId)) {
                navigate(`/home/groups/${newMessage.conversationId}`);
              } else {
                window.focus();
              }
            };
          }
        });
      }
    } else {
      if (
        notifications &&
        getNotificationSettings(newMessage?.conversationId)
      ) {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted" && document.hidden) {
            new Notification(getName(newMessage.senderId), {
              body: `Message: ${newMessage.content}`,
              icon: getProfilePic(newMessage.senderId),
            }).onclick = () => {
              window.focus();
              if (isGroup(newMessage.conversationId)) {
                navigate(`/home/groups/${newMessage.conversationId}`);
              } else {
                navigate(`/home/inbox/${newMessage.senderId}`);
              }
            };
          }
        });
      }
    }
  }, [newMessage]);

  const optionsComp = () => {
    if (openSearchUser && closeSearchUser === false && friends === false) {
      return <SearchUser closeSearchUser={searchUserClose} />;
    }
    if (friends && openSearchUser === false && closeSearchUser === false) {
      return (
        <Transition
          enter="transition ease-in duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-out duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          appear={true}
          show={friends}
        >
          <QueryClientProvider client={queryClient}>
            <Friends getCurrent={getData} openSearchUser={searchUserOpen} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
          </QueryClientProvider>
        </Transition>
      );
    }
    if (
      groups &&
      friends === false &&
      openSearchUser === false &&
      closeSearchUser === false
    ) {
      return (
        <Transition
          enter="transition ease-in duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-out duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          appear={true}
          show={groups}
        >
          <QueryClientProvider client={queryClient}>
            <SocketContext.Provider value={socket}>
              <Groups
                getCurrent={getData}
                clicked={clicked}
                openSearchUser={searchUserOpen}
                getCurrentOpenedConvo={getCurrentOpenedConvo}
                currentOpenedConvo={currentOpenedConvo}
                isMobileMenuOpen={isMobileMenuOpen}
                setIsMobileMenuOpen={setIsMobileMenuOpen}
              />
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </SocketContext.Provider>
          </QueryClientProvider>
        </Transition>
      );
    }
    if (
      codeSpace &&
      groups === false &&
      friends === false &&
      openSearchUser === false &&
      closeSearchUser === false
    ) {
      return (
        <Transition
          enter="transition ease-in duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-out duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          appear={true}
          show={codeSpace}
        >
          <QueryClientProvider client={queryClient}>
            <CodeSpace
              getForwardMessage={getForwardMessage}
              getCurrent={refreshConvo}
              isMobileMenuOpen={isMobileMenuOpen}
              setIsMobileMenuOpen={setIsMobileMenuOpen}
            />
          </QueryClientProvider>
        </Transition>
      );
    } else {
      return (
        <Transition
          enter="transition ease-in duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-out duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          appear={true}
          show={false}
        >
          <div className="bg-background w-full h-screen flex flex-col">
            <TopHeader getCreateButtonState={getCreateButtonState} />
            <SearchBar getRecentSearchText={getRecentSearchText} />
            <QueryClientProvider client={queryClient}>
              <SocketContext.Provider value={socket}>
                <ChatRow
                  getCurrent={getData}
                  getContacts={getAllContacts}
                  clicked={clicked}
                  searchText={searchRecentsText}
                  openSearchUser={createButtonPress}
                  getCurrentOpenedConvo={getCurrentOpenedConvo}
                  currentOpenedConvo={currentOpenedConvo}
                />
                {/* <ReactQueryDevtools initialIsOpen={false} /> */}
              </SocketContext.Provider>
            </QueryClientProvider>
          </div>
        </Transition>
      );
    }
  };

  const animatedComp = () => {
    return (
      <>
        <Transition
          enter="transition-opacity duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          appear={true}
          show={friends}
        >
          <QueryClientProvider client={queryClient}>
            <Friends getCurrent={getData} openSearchUser={searchUserOpen} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
          </QueryClientProvider>
        </Transition>
        <Transition
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          appear={true}
          show={groups}
        >
          <QueryClientProvider client={queryClient}>
            <SocketContext.Provider value={socket}>
              <Groups
                getCurrent={getData}
                clicked={clicked}
                openSearchUser={searchUserOpen}
                getCurrentOpenedConvo={getCurrentOpenedConvo}
                currentOpenedConvo={currentOpenedConvo}
                isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen}
              />
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </SocketContext.Provider>
          </QueryClientProvider>
        </Transition>
        <Transition
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          appear={true}
          show={codeSpace}
        >
          <QueryClientProvider client={queryClient}>
            <CodeSpace
              getForwardMessage={getForwardMessage}
              getCurrent={refreshConvo}
              isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen}
            />
          </QueryClientProvider>
        </Transition>
        <Transition
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          appear={true}
          show={!friends && !groups && !codeSpace}
        >
          <div className="bg-background w-full h-screen flex flex-col">
            <TopHeader getCreateButtonState={getCreateButtonState} isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
            <SearchBar getRecentSearchText={getRecentSearchText} />
            <QueryClientProvider client={queryClient}>
              <SocketContext.Provider value={socket}>
                <ChatRow
                  getCurrent={getData}
                  getContacts={getAllContacts}
                  clicked={clicked}
                  searchText={searchRecentsText}
                  openSearchUser={getCreateButtonState}
                  getCurrentOpenedConvo={getCurrentOpenedConvo}
                  currentOpenedConvo={currentOpenedConvo}
                />
                {/* <ReactQueryDevtools initialIsOpen={false} /> */}
              </SocketContext.Provider>
            </QueryClientProvider>
          </div>
        </Transition>
      </>
    );
  };

  return (
    <>
      {!screen ? (
        <Navigate to={`/home/inbox`} />
      ) : (
        <div className="flex h-screen w-screen   antialiased  ">
          {/* Global Hamburger Menu Button REMOVED */}
          <div className={`fixed inset-y-0 left-0 z-30 flex flex-col transform ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} sm:relative sm:translate-x-0 sm:w-16 md:w-20 lg:w-[5%] border-r border-secondary h-full bg-palette_color1 transition-transform duration-300 ease-in-out`}>
            <ReactTooltip delayShow={500} delayHide={100} />
            <div
              className=" flex items-center justify-center h-[10%] "
              data-tip={backendService.getLoggedInUser().name}
              data-place="right"
            >
              <img
                alt="Profile"
                className="mt-5 rounded-full h-[45px] w-[45px] cursor-pointer "
                src={
                  profilePictureLoaded
                    ? profilePicture !== null
                      ? profilePicture
                      : require("../assets/boredApe.png")
                    : require("../assets/boredApe.png")
                }
              />
            </div>
            <div className=" h-[90%]  flex items-center justify-center">
              <QueryClientProvider client={queryClient}>
                <SocketContext.Provider value={socket}>
                  <VerticalMenu
                    openSearchUser={searchUserOpen}
                    friends={friendsTab}
                    notification={getNotifications}
                    groups={groupsTab}
                    openFriends={createButtonPress}
                    codeSpace={codeSpaceTab}
                    setIsMobileMenuOpen={setIsMobileMenuOpen}
                  />
                </SocketContext.Provider>
              </QueryClientProvider>
            </div>
          </div>
          {isMobileMenuOpen && (
            <div
              className="fixed inset-0 z-20 bg-black opacity-50 sm:hidden"
              onClick={() => setIsMobileMenuOpen(false)}
            ></div>
          )}
          <div className={`h-full overflow-hidden ${mobileView === 'chat' ? 'hidden md:block' : 'block w-full'} md:w-1/3 lg:w-1/4 xl:w-1/5`}>{animatedComp()}</div>
          <div className={`h-screen flex-col justify-start bg-gradient-to-b from-[#f5f5f5] to-[#dddddd] bg-no-repeat bg-cover bg-center ${mobileView === 'list' ? 'hidden' : 'flex w-full'} md:flex md:flex-1`}>
            <>
              {currentConvo === null ? (
                <div className="justify-center items-center h-screen bg-gray-100 border-b-8 border-palette_color1 flex md:flex">
                  <div className="">
                    <img
                      className="object-contain h-[150px] w-[150px]"
                      src={require("../assets/ChatDev-01.png")}
                      alt="Share Code Snippet"
                    />
                  </div>
                </div>
              ) : (
                <>
                  <ChatHeader
                    userInfo={currentConvo}
                    group={groups}
                    clicked={setClicked}
                    refresh={refreshConvoAlt}
                    onBackButtonClick={handleBackToList}
                  />
                  {isLoading && currentConvo !== null ? (
                    <div className="overflow-hidden flex flex-auto justify-center items-center ">
                      {/* <QuipComponent /> */}
                      <HashLoader
                        size={150}
                        color={"#0077b6"}
                        loading={isLoading}
                      />
                    </div>
                  ) : (
                    <>
                      <div
                        id="scrollableDiv"
                        className="flex flex-col-reverse flex-1 overflow-y-scroll overflow-x-hidden chat__container"
                      >
                        <InfiniteScroll
                          className="chat__container"
                          dataLength={messageRef.current.length}
                          next={async () => await infiniteMessage()}
                          inverse={true} //
                          hasMore={hasPagesRef.current}
                          scrollableTarget="scrollableDiv"
                          // style={{
                          //   scrollbarWidth: "thin",
                          //   scrollbarColor: "#525252 #121212",
                          // }}
                          style={{
                            display: "flex",
                            flexDirection: "column-reverse",
                            overflow: "hidden",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#525252 #121212",
                          }}
                          loader={
                            //create col div
                            <div className="flex flex-row justify-center my-2 items-center h-full">
                              <Oval stroke="#0077b6" height={"1.3rem"} />
                              <h4 className="text-center text-xl text-palette_color1">
                                Loading messages ...
                              </h4>
                            </div>
                          }
                        >
                          <Chatfeed
                            messages={messages}
                            reciever={currentConvo.participants[0]._id}
                            userInfo={currentConvo}
                            getForwardMessage={getForwardMessage}
                            getDeleteMessage={getDeleteMessage}
                            getEditMessage={editedCode}
                          />
                        </InfiniteScroll>
                      </div>
                      <ChatInput
                        getInputText={getInputText}
                        send={sendMessage}
                        userInfo={currentConvo}
                        sendCodeData={getCodeData}
                        sendImageData={getImageData}
                        sendVideoData={getVideoData}
                        sendFileData={getFileData}
                        sendAudioData={getAudioData}
                      />
                    </>
                  )}
                </>
              )}
            </>
          </div>
        </div>
      )}
    </>
  );
}

export default MainScreen;
